import {EmailFilterModel, GetMessageModel, SpecialFolder, SuperBit_swaggerClient} from './superbit-api-models';
import generalSettings from '../json/general-settings.json';

export class EmailsModel {
    client:any;
    constructor() {
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        const apiUrl = localStorage.getItem('apiUrl');
        this.client = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
    }

    async getEmailsSettings() {
        return await this.client.emailsSettings();
    }

    async getFolders(activeEmail: string) {
        const folders = await this.client.emailsRetrieveFolders(activeEmail);
        // console.log('processEmailsRetrieveFolders', folders);
        return folders
    }

    async getAllEmails(){
        return await this.client.emailsIndex({});
    }

    async getFilteredlEmails(filter: EmailFilterModel){
        return await this.client.emailsFilter(filter);
    }

    async getMessage (data: GetMessageModel) {
        return await this.client.emailsGetMessage(data);
    }

    async moveEmailToFolder (sourceFolder: string | undefined | null, type: SpecialFolder | undefined | null, destFolderName: string | undefined, messageId: number[] | undefined, activeMail: string) {
        return await this.client.emailsMoveEmailToFolder(sourceFolder, type, destFolderName, messageId, activeMail);
    }

    async emailsGetAddresses (activeEmail: string) {
        return await this.client.emailsGetAddresses(activeEmail);
    }

    async emailsSendMessage (formData: any) {
        return await this.client.emailsSendMessage(formData);
    }

    async emailsCreateNewFolder (folderName: string, activeMail: string) {
        return await this.client.emailsCreateNewFolder(folderName, activeMail);
    }

    async getLeadsForRelations () {
        return await this.client.treatmentsLoadLeadsForRelations('lead');
    }

    async getCustomersForRelations () {
        return await this.client.treatmentsLoadCustomersForRelations();
    }

    async emailsSaveMessageAsTreatment (body: any) {
        return await this.client.emailsSaveMessageAsTreatment(body);
    }

    async emailsAddRemoveStar(body: any) {
        return await this.client.emailsAddRemoveStar(body);
    }
    async emailsToggleReadMode(body: any) {
        return await this.client.emailsAddRemoveRead(body);
    }

    async emailsRemoveMessage(body: any) {
        return await this.client.emailsRemoveMessage(body);
    }

}